import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  baseBoxShadowFocus,
  borderRadius8,
} from 'approot/shared/styles/borders.style';
import { viewport16by9Ratio } from './playable.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { ComponentOverlayButton } from './component-overlay/component-overlay.style';
import {
  PRESENT_COMPONENT_RESPONSE_Z_INDEX,
  PRESENT_PLAYABLE_COMPONENT_INFO_BUTTON_Z_INDEX,
} from 'approot/activity-builder/present/activity-builder-present.constants';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import { spacing12 } from 'approot/shared/styles/spacing.style';

type CoverImageProps = {
  $backgroundImg?: string | null;
  $fullBorderRadius?: boolean;
  $noPaddingTop?: boolean;
  $noCover?: boolean;
};

export const PlayableComponentCover = styled.div<CoverImageProps>`
  ${viewport16by9Ratio}

  ${({ $backgroundImg, $noCover }) =>
    $backgroundImg &&
    `
    background-image: url(${$backgroundImg});
    background-repeat: no-repeat;
    background-size: ${$noCover ? 'contain' : 'cover'};
    background-position: center;
  `}

  border-radius: ${({ $fullBorderRadius }) =>
    $fullBorderRadius
      ? rem(borderRadius8)
      : `${rem(borderRadius8)} ${rem(borderRadius8)} 0 0`};

  ${({ $noPaddingTop }) => $noPaddingTop && `padding-top: 0;`}
`;

const playButtonCss = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${PRESENT_COMPONENT_RESPONSE_Z_INDEX};

  &:hover {
    cursor: pointer;
  }
`;

export const PlayableComponentButtonText = styled(ComponentOverlayButton)``;

type PlayableComponentButtonProps = {
  $noBackground?: boolean;
};
export const PlayableComponentButton = styled.button<PlayableComponentButtonProps>`
  ${playButtonCss}

  ${({ $noBackground }) =>
    !$noBackground &&
    `
    background-color: rgba(0, 0, 0, 0.2);
  `}

  border-radius: ${rem(borderRadius8)};
  border: none;
  padding: 0;
  width: 100%;

  &:focus {
    outline: none;
    ${PlayableComponentButtonText} {
      box-shadow: inset ${baseBoxShadowFocus};
      outline: 0;
    }
  }
`;

export const PlayableComponentStaticButton = styled.div`
  ${flexCentreAlignCss}
  ${playButtonCss}
`;

export const PlayableComponentInfoButton = styled(SecondaryButtonIcon)`
  position: absolute;
  top: ${rem(spacing12)};
  right: ${rem(spacing12)};
  z-index: ${PRESENT_PLAYABLE_COMPONENT_INFO_BUTTON_Z_INDEX};
`;
